export const EDITOR_AGENT_CALLOUT_DISMISSED_AT_STORAGE_KEY =
  "replo.editor.agentCalloutDismissedAt";

export const EDITOR_V1_MIGRATION_BANNER_DISMISSED_STORAGE_KEY =
  "replo.editor.v1MigrationBannerDismissed";
